module.exports = __webpack_public_path__ + "massage-model-desktop-ea3572.webp";